// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 500px) {\n.login_content[data-v-0e137849] {\n    min-height: 736px;\n}\n.login_content.isPopFrame[data-v-0e137849] {\n      min-height: 615px;\n}\n}\n@media (max-width: 499px) {\n.login_contenter .login_content .login_cont .login_form .login_form_cont[data-v-0e137849] {\n    min-height: 406px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
